import React from "react";
import { Tooltip, Form, Badge } from "antd";
import { connect } from "dva";
import { router } from "umi";
import Container from "../../../../components/Container";
import ListPage from "../../../../components/ListPage";
import ListSearch from "./Components/Search";
import getList from "../../../../services/activitySign/dataStatistic/index";
import { GetQueryString } from "../../../../utils/utils";
import { getComposeUrl } from "../../../../utils/common";
import useRequest from "./hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;

const statusIcon = {
  草稿: "warning",
  进行中: "processing",
  已结束: "default"
};


const DataStatistic = props => {
  const appId = GetQueryString("appId") || 40;
  const {
    pageInfo,
    list,
    loading,
    handlePaginationChange,
    handleQueryChange
  } = useRequest(getList);

  const handleJump = (record, jumpPath) => {
    const { pathname } = window.location;
    const { activityBizId } = record;
    router.push(
      getComposeUrl(
        `${pathname}/${jumpPath}?activityBizId=${activityBizId}&appId=${appId}`
      )
    );
  };

  const columns = [
    {
      title: "活动名称",
      dataIndex: "name",
      key: "name",
      width: 330,
      fixed: "left",
      render: name =>
        name ? (
          <Tooltip placement="top" title={name}>
            <span>
              {name && name.length <= 20 ? name : `${name.substring(0, 20)}...`}
            </span>
          </Tooltip>
        ) : (
          <span>-</span>
        )
    },
    {
      title: "活动状态",
      dataIndex: "statusDesc",
      key: "statusDesc",
      width: 120,
      render: statusDesc => (
        <Badge status={statusIcon[statusDesc]} text={statusDesc} />
      )
    },
    {
      title: "创建人",
      dataIndex: "userName",
      key: "userName",
      width: 120
    },
    {
      title: "创建时间",
      dataIndex: "gmtCreate",
      key: "gmtCreate",
      width: 150
    },
    {
      title: "日数据统计",
      key: "dailyStatistic",
      width: 120,
      render: record => {
        return (
          <span
            style={{ color: "#1785EC" }}
            onClick={() => handleJump(record, "dailyStatistic")}
          >
            查看详情
          </span>
        );
      }
    },
    {
      title: "汇总统计",
      key: "summaryStatistic",
      width: 120,
      render: record => {
        return (
          <span
            style={{ color: "#1785EC" }}
            onClick={() => handleJump(record, "summaryStatistic")}
          >
            查看详情
          </span>
        );
      }
    },
    {
      title: "指标汇总",
      key: "normSummary",
      width: 120,
      render: record => {
        return (
          <span
            style={{ color: "#1785EC" }}
            onClick={() => handleJump(record, "normSummary")}
          >
            查看详情
          </span>
        );
      }
    },
    {
      title: "积分榜单",
      key: "pointRank",
      width: 160,
      fixed: "right",
      render: record => {
        return (
          <span
            style={{ color: "#1785EC" }}
            onClick={() => handleJump(record, "pointRank")}
          >
            查看详情
          </span>
        );
      }
    }
  ];

  const containerProps = {
    breStates: 1,
    isSplitBar: 1,
    alertParams: {
      states: !0, // true为展示 false不展示
      type: "info", // 错误类型（success info warning error）四种，默认为warning类型
      message:
        "可查看本校与本校相关所有活动的统计数据， 所有数据在当日凌晨更新统计，今日创建的活动在第二天呈现" // 展示的内容
    }
  };

  const { form } = props;

  const searchProps = {
    handleQueryChange,
    form
  };

  const listPageProps = {
    spinProps: {
      spinning: loading
    },
    className: styles.root
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    selfPageNation: pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <Container {...containerProps}>
      <ListPage {...listPageProps}>
        <ListSearch {...searchProps} />
        <div className="divider" />
        <ListTable {...tableProps} />
      </ListPage>
    </Container>
  );
};

export default connect()(Form.create()(DataStatistic));
